import {View} from 'MWC';
import mainTpl from '../../templates/order/kdv';

class OrderKDV extends View {
    template = mainTpl;

    static displayName = 'Cards.Views.OrderKDV';
}

export default OrderKDV;
